import FilterSheet from "@/components/sheets/FilterSheet";
import FilterSortSection from "@/components/sheets/FilterSheet/FilterSortSection";

const sorts = {
	default: "Default",
	"createdAt:desc": "Latest",
	"createdAt:asc": "Oldest",
	"isPopular:desc": "Popular",
} as const;

export default function FilterPopup() {
	return (
		<FilterSheet glassToolbar removeParamsWhen={{ sortBy: "default" }}>
			<FilterSortSection sorts={sorts} defaultSort="default" />
			<hr className="my-6 border-t border-secondary/30" />
		</FilterSheet>
	);
}
